export default class InvoicePaymentMethod {
  id: string;

  allowedFlows: string[];

  logo: string;

  name: string;

  type: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.allowedFlows = obj.allowedFlows || [];
    this.logo = obj.logo || '';
    this.name = obj.name || '';
    this.type = obj.type || '';
  }
}
